'use strict'

import modal from 'Modules/modal'

/**
 * Conversion Rate Optimization
 *
 * Module d'optimisation du taux de conversion
 *
 *
 */

export class CRO {
    _shouldShowModal
    _hasModalAlreadyPopped
    _lastTimeMouseMoved
    _intervalId

    constructor() {
        this._shouldShowModal = false
        this._hasModalAlreadyPopped = false
        this._lastTimeMouseMoved = null
        this._intervalId = null
        this.MAX_IDLE_TIME_SECONDS = 7
        this.MAX_PIXELS_FROM_WINDOW_BORDER = 7
    }

    handleModalForm = () => {
        $('#modal-cro-form').on('submit', (e) => {
            e.preventDefault()

            const email = e.target[0].value

            $.post('/Inscription/SavePanierNonLoggueEmail', { email }).then(
                (response) => {
                    if (!response.ok) {
                        $('.modal-cro-content__merci').html(
                            '<p>Une erreur est survenue.<p></p>Merci de réessayer plus tard.</p>'
                        )
                    }
                    $('.modal-cro-content__form').hide()
                    $('.modal-cro-content__img').hide()
                    $('.modal-cro-content__merci').removeClass('hidden')
                }
            )
        })
    }

    /**
     * Track le temps d'inactivité de l'utilisateur
     */
    trackIdle = () => {
        if (this._shouldShowModal) {
            return
        }

        const self = this

        clearInterval(this._intervalId)

        this._lastTimeMouseMoved = null

        this._intervalId = setInterval(() => {
            const currentTime = Date.now()

            if (self._lastTimeMouseMoved == null) {
                self._lastTimeMouseMoved = currentTime
            }

            const shouldShowModal =
                Math.abs((self._lastTimeMouseMoved - currentTime) / 1000) >=
                self.MAX_IDLE_TIME_SECONDS

            if (!shouldShowModal) {
                return
            }

            self._shouldShowModal = true

            clearInterval(self._intervalId)
        }, 1000)
    }

    /**
     * Track la souris pour voir si elle sort de l'écran
     * @param {MouseEvent} e event
     */
    trackMouse = (e) => {
        const { clientY: y, clientX: x } = e

        const userIsLeavingWindow =
            y <= this.MAX_PIXELS_FROM_WINDOW_BORDER ||
            window.innerHeight - y <= this.MAX_PIXELS_FROM_WINDOW_BORDER

        this._hasModalAlreadyPopped = userIsLeavingWindow

        if (!userIsLeavingWindow || !this._shouldShowModal) {
            return
        }

        const self = this

        modal.creer(
            'modal-cro',
            '',
            window.location.origin + '/Layout/GetCROModal',
            function () {
                self.handleModalForm()
            }
        )
    }

    /**
     * Appelle les fonctions de tracking
     * @param {MouseEvent} e event
     */
    trackUser = (e) => {
        if (this._hasModalAlreadyPopped) {
            return
        }

        this.trackIdle()
        this.trackMouse(e)
    }

    /**
     * Instancie les events listener
     */
    init() {
        const self = this

        window.addEventListener('mousemove', (e) => {
            self.trackUser(e)
        })

        onbeforeunload = () => {
            window.removeEventListener('mousemove', (e) => {
                self.trackUser(e)
            })
        }
    }
}
